<template>
    <Card class="mb-4">
      <template #header>
        <h2 class="mb-0" @click="toggleLeistungen()">Leistungen</h2>
      </template>
      <div v-if="show_leistungen">
        <div>
          <label>Diebstahl Elektro Kabel</label>
          <BaseSelect
            v-model="offer.softfair_diebstahl_elektro_kabel"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Deckungssummen Haftpflicht</label>
          <BaseSelect
            v-model="offer.softfair_deckungssummen_haftpflicht"
            :options="deckungssummenOptions"
          />
        </div>

        <div>
          <label>Rabattschutz Haftpflicht</label>
          <BaseSelect
            v-model="offer.softfair_rabattschutz_haftpflicht"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Akku Fehler durch Bedienung</label>
          <BaseSelect
            v-model="offer.softfair_akku_fehler_durch_bedienung"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Ausgleich Akku Leasing</label>
          <BaseSelect
            v-model="offer.softfair_ausgleich_akku_leasing"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Umweltschadenversicherung</label>
          <BaseSelect
            v-model="offer.softfair_umweltschadenversicherung"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Rabattschutz Vollkasko</label>
          <BaseSelect
            v-model="offer.softfair_rabattschutz_vollkasko"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Recht auf Schadenrückkauf Kasko</label>
          <BaseSelect
            v-model="offer.softfair_recht_auf_schadenrueckkauf_kasko"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Hacker und Cyber Angriff</label>
          <BaseSelect
            v-model="offer.softfair_hacker_und_cyber_angriff"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Neuwertentschädigung Akku</label>
          <BaseSelect
            v-model="offer.softfair_neuwertentschaedigung_akku"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Pannenhilfe Akku</label>
          <BaseSelect
            v-model="offer.softfair_pannenhilfe_akku"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Betriebs- und Bremsbruchschäden</label>
          <BaseSelect
            v-model="offer.softfair_betriebs_brems_bruch_schaeden"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Verzicht auf Selbstbeteiligung bei Glasreparatur</label>
          <BaseSelect
            v-model="offer.softfair_verzicht_auf_selbstbeteiligung_bei_glasreparatur"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Verzicht auf Abzug Neu für Alt</label>
          <BaseSelect
            v-model="offer.softfair_verzicht_auf_abzug_neu_fuer_alt"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Personen Deckungssumme Haftpflicht</label>
          <BaseSelect
            v-model="offer.softfair_personen_deckungssumme_haftpflicht"
            :options="personenDeckungssummeOptions"
          />
        </div>

        <div>
          <label>Neuwertentschädigung</label>
          <BaseSelect
            v-model="offer.softfair_neuwertentschaedigung"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Überführungskosten</label>
          <BaseSelect
            v-model="offer.softfair_ueberfuehrungskosten"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Fahrerschutzversicherung</label>
          <BaseSelect
            v-model="offer.softfair_fahrerschutzversicherung"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Zusatzleistungen Elektro- und Hybridfahrzeuge</label>
          <BaseSelect
            v-model="offer.softfair_zusatzleistungen_elektro_und_hybridfahrzeuge"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Schäden zwischen ziehendem und gezogenem Fahrzeug</label>
          <BaseSelect
            v-model="offer.softfair_schaeden_zwischeniehendem_und_gezogenem_fahrzeug"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Dachlawinen</label>
          <BaseSelect
            v-model="offer.softfair_dachlawinen"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Parkschadenschutz</label>
          <BaseSelect
            v-model="offer.softfair_parkschadenschutz"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Kosten für Wassercontainer</label>
          <BaseSelect
            v-model="offer.softfair_kosten_fuer_wassercontainer"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Auslandschadenschutz</label>
          <BaseSelect
            v-model="offer.softfair_auslandschadenschutz"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Eigenschadendeckung</label>
          <BaseSelect
            v-model="offer.softfair_eigenschadendeckung"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Wertminderungsausgleich bei Reparaturschäden</label>
          <BaseSelect
            v-model="offer.softfair_wertminderungsausgleich_bei_reparaturschaeden"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>All Risk Akku Elektro</label>
          <BaseSelect
            v-model="offer.softfair_all_risk_akku_elektro"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Mobile Ladegeräte</label>
          <BaseSelect
            v-model="offer.softfair_mobile_ladegeraete"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Überspannungsschäden am Akku</label>
          <BaseSelect
            v-model="offer.softfair_ueberspannungsschaeden_am_akku"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Entsorgungskosten</label>
          <BaseSelect
            v-model="offer.softfair_entsorgungskosten"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Werkstattbindung</label>
          <BaseSelect
            v-model="offer.softfair_werkstattbindung"
            :options="werkstattbindungOptions"
          />
        </div>

        <div>
          <label>Tierbissfolge Schäden</label>
          <BaseSelect
            v-model="offer.softfair_tierbissfolge_schaeden"
            :options="tierbissfolgeOptions"
          />
        </div>

        <div>
          <label>Entsorgungskosten Akku</label>
          <BaseSelect
            v-model="offer.softfair_entsorgungskosten_akku"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>All Risk</label>
          <BaseSelect
            v-model="offer.softfair_all_risk"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Unfallmeldedienst</label>
          <BaseSelect
            v-model="offer.softfair_unfallmeldedienst"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Zulassungskosten</label>
          <BaseSelect
            v-model="offer.softfair_zulassungskosten"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Verzicht auf Einwand grober Fahrlässigkeit</label>
          <BaseSelect
            v-model="offer.softfair_verzicht_auf_einwand_grober_fahrlaessigkeit"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Kurzschlussfolgeschäden Elektro</label>
          <BaseSelect
            v-model="offer.softfair_kurzschlussfolgeschaeden_elektro"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Recht auf Schadenrückkauf KH</label>
          <BaseSelect
            v-model="offer.softfair_recht_auf_schadenrueckkauf_kh"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Kaufwertentschädigung</label>
          <BaseSelect
            v-model="offer.softfair_kaufwertentschaedigung"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Diebstahl Elektro Ladekarte</label>
          <BaseSelect
            v-model="offer.softfair_diebstahl_elektro_ladekarte"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Mallorcapolice</label>
          <BaseSelect
            v-model="offer.softfair_mallorcapolice"
            :options="mallorcapoliceOptions"
          />
        </div>

        <div>
          <label>Telematik</label>
          <BaseSelect
            v-model="offer.softfair_telematik"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Akku Ausgleich Leasing Akku</label>
          <BaseSelect
            v-model="offer.softfair_akku_ausgleich_leasing_akku"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Sonstige Leistungen Elektro- und Hybridfahrzeuge</label>
          <BaseSelect
            v-model="offer.softfair_sonstige_leistungen_elektro_und_hybridfahrzeuge"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Leistungsupdate Garantie</label>
          <BaseSelect
            v-model="offer.softfair_leistungs_update_garantie"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Tierbiss Folgeschäden Elektro</label>
          <BaseSelect
            v-model="offer.softfair_tierbiss_folgeschaeden_elektro"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Elementarschäden</label>
          <BaseSelect
            v-model="offer.softfair_elementarschaeden"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Schutzbrief</label>
          <BaseSelect
            v-model="offer.softfair_schutzbrief"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>GAP Deckung</label>
          <BaseSelect
            v-model="offer.softfair_gap_deckung"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Wallboxen</label>
          <BaseSelect
            v-model="offer.softfair_wallboxen"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Beitragsfrei mitversicherter Mehrwert</label>
          <BaseSelect
            v-model="offer.softfair_beitragsfrei_mitversicherter_mehrwert"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Kurzschlussfolgeschäden</label>
          <BaseSelect
            v-model="offer.softfair_kurzschlussfolgeschaeden"
            :options="unwichtigGewuenschtOptions"
          />
        </div>

        <div>
          <label>Kollision mit Tieren</label>
          <BaseSelect
            v-model="offer.softfair_kollision_mit_tieren"
            :options="unwichtigGewuenschtOptions"
          />
        </div>
      </div>
    </Card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BaseSelect from '@/components/Inputs/BaseSelect.vue';
import Card from '@/components/Cards/Card.vue';

export default {
    name: "softfair-leistungen",
    components: {
        BaseSelect,
        Card,
    },
    data() {
        return {
            loading: false,
            show_leistungen: false,
            unwichtigGewuenschtOptions: ['Unwichtig', 'Gewuenscht'],
            deckungssummenOptions: ['Euro100MioJeSchaden', 'Euro50MioJeSchaden', 'Euro25MioJeSchaden'],
            personenDeckungssummeOptions: ['Euro12MioJeSchaden', 'Euro8MioJeSchaden', 'Euro5MioJeSchaden'],
            tierbissfolgeOptions: ['TierbissFolgeschaedenBis5_000Euro', 'TierbissFolgeschaedenBis10_000Euro', 'Unwichtig'],
            werkstattbindungOptions: ['OhneWerkstattbindung', 'MitWerkstattbindung'],
            mallorcapoliceOptions: ['DeckungWieHaftpflichtversicherung', 'Unwichtig']
        };
    },
    methods: {
        toggleLeistungen() {
            this.show_leistungen = !this.show_leistungen;
        },
        setDefaults() {
        },
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      return Number.parseFloat(x).toFixed(2);
    },

    fetchParticipations() {
      this.loading = true;
      let qtp = "car";
      if (this.offer.is_van) {
        qtp = 'van';
      }
      this.$api
        .getParticipations(qtp)
        .then((response) => {
          this.offer.participations = response.data.items.map((item) => {
            let str = "";

            if (item.vk > 0) {
              str += "Vollkasko SB " + item.vk + " ";
            }
            
            str += "Teilkasko SB " + item.tk + " ";

            if (item.name == "Nur Haftpflicht") {
              str = item.name;
            }

            return { value: item.id, label: str };
          });
        })
        .catch((e) => {
          //console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    },
    computed: {
        ...mapGetters({ 
            currentAccount: "currentAccount"
        }),
        ...mapState({
            account: state => state.account,
            offer: (state) => state.softfairOffer,
        }),
    },
    mounted() {
      this.fetchParticipations();
    },
};
</script>
<style></style>